/* eslint-disable react/prop-types */ // TODO: add props
import styles from './ChecklistDescription.scss';

const ChecklistDescription = ({ children }) => (
  <span
    className={styles.checklistDescription}
    dangerouslySetInnerHTML={{ __html: children }}
  />
);

export default ChecklistDescription;
